(function ($) {

    $(function () {

        window.toggleExpandFeaturedEvents = function (target) {
            $button = $(target);
            $component = $(target).parents(".featured-events");
            $expandableContent = $component.find(".expandable");
            if ($expandableContent.is(":visible")) {
                $expandableContent.slideUp(300);
                $button.html("View More Sessions <span class=\"fa-solid fa-arrow-down\"></span>");
            }
            else {
                $expandableContent.slideDown(300);
                $button.html("Hide More Sessions <span class=\"fa-solid fa-arrow-up\"></span>");
            }
        };

    });

})($JQ);
